export enum CallDispositionEnum {
  NP = '- No Disposition -',
  CP = 'Called Payer',
  CCSAP = 'Checked Claim Status via Automated Phone (IVR)',
  CLMPI = 'Left Message with Primary Insurance',
  CLMSI = 'Left Message with Secondary Insurance',
  CINNA = 'Called Insurance, No Answer',
  CINLB = 'Called Insurance, Line Busy',
  TE = 'Technical Error',
}

export enum UseCaseEnum {
  CSI = 'CSI',
  EBV = 'EBV',
  EOB = 'EOB',
  NoVirtualAgent = 'NoVirtualAgent',
  DirectLine = 'DirectLine',
  WorkersComp = 'WorkersComp',
  ASC = 'ASC',
}

export enum UseCaseEnumToUseCaseIdEnum {
  CSI = 1,
  EBV = 2,
  EOB = 3,
  NoVirtualAgent = 4,
  DirectLine = 5,
  WorkersComp = 6,
  ASC = 7,
}

export enum CallTypeEnum {
  unattended = 'Unattended',
  humanAgent = 'HumanAgent',
  standard = 'Standard',
  attendable = 'Attendable',
  diagnosticHeadset = 'DiagnosticHeadset',
}

export enum AutomationTypeEnum {
  fullCSI = 'FullCSI',
  getPayer = 'GetPayer',
  basic = 'Basic',
  ASC = 'ASC',
  los1 = 'LOS1',
  los2 = 'LOS2',
  los3 = 'LOS3',
  los4 = 'LOS4',
  los5 = 'LOS5',
  los6 = 'LOS6',
  los7 = 'LOS7',
  los8 = 'LOS8',
  los9 = 'LOS9',
  los10 = 'LOS10',
  los11 = 'LOS11',
  notSupported = 'NotSupported',
}

export enum CallTypeToJobTypeEnum {
  claimStatus = 3,
  humanAgent = 6,
  standard = 7,
  diagnosticHeadset = 8,
  APIIntegration = 9,
  attendable = 11,
}

export enum CallInfoKindEnum {
  string = 'string',
  number = 'number',
  date = 'date',
  boolean = 'boolean',
}

export enum CallsConstantsEnum {
  timerTimeout = 1500,
  successTimeout = 1000,
}

export enum CallMessageDirectionEnum {
  incoming = 'incoming',
  outgoing = 'outgoing',
}

export enum CallResourcesEnum {
  recording = 'recording',
  transcripts = 'transcripts',
}

export enum CallParticipantTypeEnum {
  // TAKEOVER: At present the transcripts are faked to show twilioParticipant and browserParticipant like they used to but it might be wise to know the difference
  foreignPhoneParticipant = 'ForeignPhoneParticipant',
  domesticPhoneParticipant = 'DomesticPhoneParticipant',
  twilioParticipant = 'TwilioParticipant',
  browserParticipant = 'BrowserParticipant',
  browserHeadsetParticipant = 'BrowserHeadsetParticipant',
  dataExtractionParticipant = 'DataExtractionParticipant',
  AIAgentParticipant = 'AIAgentParticipant',
  HCAgentParticipant = 'HCAgentParticipant',
  transcriptEventDetectorParticipant = 'TranscriptEventDetectorParticipant',
  diagnosticParticipant = 'DiagnosticParticipant',
  dataPersistenceParticipant = 'DataPersistenceParticipant',
  audioSynthesizerParticipant = 'AudioSynthesizerParticipant',
  streamManagerParticipant = 'StreamManagerParticipant',
  jobSchedulerParticipant = 'JobSchedulerParticipant',
  DoubleTranscription = 'DoubleTranscription',
}

export const callParticipantTypesOurUser: CallParticipantTypeEnum[] = [
  CallParticipantTypeEnum.domesticPhoneParticipant,
  CallParticipantTypeEnum.browserParticipant,
]

export enum CallStatusEnum {
  FailedToQueue = 0,
  Queued,
  InProgress,
  Complete,
  FailedToComplete,
  Canceled = 5,
  RetryPending = 6,
  StoppedRepeatCall = 7,
  Unknown,
}
export enum CallStatusDetailEnum {
  None = 0,
  InProgress = 1,
  Canceled = 2,
  CompletedSuccess = 3,
  InternalSystemError = 4,
  InvalidData = 5,
  PhoneSystemError = 6,
  MaxTimeInQueueExceeded = 7,
  MaxNumberAttemptExceeded = 8,
  BadOriginatingNumber = 9,
  FailedNoAnswer = 10,
  FailedBusy = 11,
  CallFailed = 12,
  SystemHangUp = 13,
  HumanHangUp = 14,
  HumanTakeoverFailed = 15,
  StoppedRepeatCall = 16,
}
